import React, { useEffect, useState } from "react";
import { fetchEntityById, } from "../../../apis/apiService";
import { toast } from "react-toastify";
import {Paper, Table,TableBody, TableCell, TableContainer, TableHead, TableRow,Typography,} from "@mui/material";
import { useSelector } from "react-redux";

export const TaskBudget = ({ current_id }) => {
  //console.log("API Response (filteredData):", filteredData);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // console.log("login_user in task:", login_user);
  const { role: login_user_role, } = login_user;
  const handleApiCall = async () => {
    //   const users = watch("users");
    //console.log("user_changed : ", users);
    setLoading(true);
    // const projectSpan = watch("project_span");
    // const requestedData = {
    //   project_span: project_span || projectSpan, // Week, Month, or All
    //   from_date: from_date,
    //   to_date: to_date,
    //   users,
    // };

    try {
      const response = await fetchEntityById(`task/budgetTracking`, current_id);
      setFilteredData(response); // Update the filtered data
      toast.success(response.message);
    } 
    catch (error) {
      const errorMsg = error.message;
      setFilteredData([]);
      toast.error(errorMsg);
    } 
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (login_user_role === "ADMIN" || login_user_role === "MANAGER") {
      handleApiCall();
    }
  }, [current_id, login_user_role]);
  // Check if data exists
  const groupedData = filteredData?.data?.grouped_data || {};
  const hasData = Object.keys(groupedData).length > 0;

  // Show "No Data Found" if there's no data
  if (!hasData) {
    return (
      <Typography
        variant="h6"
        align="center"
        sx={{ margin: "20px", color: "gray" }}
      >
        No Data Found
      </Typography>
    );
  }

  // Transform API data for rendering
  const data = [];
  for (const [id, group] of Object.entries(groupedData)) {
    const { name, rates } = group;
    const overallTotalAmount = group?.rates?.total_amount || 0;
    const overallTotalHours = group?.rates?.total_hours || 0;

    const rows =
      rates?.details?.length > 0
        ? rates.details.map((detail) => ({
            hours: detail.hours || 0,
            rate: detail.rate || "No Data",
            startDate: detail.start_date || "No Data",
            endDate: detail.end_date || "No Data",
            totalHrs: detail.hours || "No Data",
            totalAmount: detail.hours * detail.rate || 0,
          }))
        : [
            {
              hours: 0,
              rate: "No Data",
              startDate: "No Data",
              endDate: "No Data",
              totalHrs: "No Data",
              totalAmount: 0,
            },
          ];

    data.push({
      id,
      name: name || "No Data",
      rows,
      totalHours: overallTotalHours,
      totalAmount: overallTotalAmount,
    });
  }

  //console.log("Transformed Data for Table Rendering:", data);

  return (
    <TableContainer component={Paper} sx={{ maxHeight: 500, mt: 3 }}>
      <Table stickyHeader sx={{ boxShadow: "none", border: "none" }}>
        <TableHead>
          <TableRow
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 2,
              backgroundColor: "#fff",
            }}
          >
            <TableCell>S.No</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Hours</TableCell>
            <TableCell>Rate / hr</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>End Date</TableCell>
            <TableCell>Total Hrs</TableCell>
            <TableCell>Total Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((group, groupIndex) => (
            <React.Fragment key={group.id}>
              {group.rows.map((row, rowIndex) => (
                <TableRow key={`${group.id}-${rowIndex}`}>
                  {rowIndex === 0 && (
                    <>
                      <TableCell rowSpan={group.rows.length}>
                        {groupIndex + 1}
                      </TableCell>
                      <TableCell rowSpan={group.rows.length}>
                        {group.name}
                      </TableCell>
                    </>
                  )}
                  <TableCell>{row.hours}</TableCell>
                  <TableCell>{row.rate}</TableCell>
                  <TableCell>{row.startDate}</TableCell>
                  <TableCell>{row.endDate}</TableCell>
                  {rowIndex === 0 ? (
                    <>
                      <TableCell rowSpan={group.rows.length}>
                        {group.totalHours}
                      </TableCell>
                      <TableCell rowSpan={group.rows.length}>
                        {group.totalAmount}
                      </TableCell>
                    </>
                  ) : null}
                </TableRow>
              ))}
            </React.Fragment>
          ))}

          {/* Overall Total Row */}
          <TableRow
            sx={{
              position: "sticky",
              bottom: 0,
              zIndex: 2,
              backgroundColor: "var(--cell-bg-color)",
            }}
          >
            <TableCell colSpan={7} align="right">
              <span>Overall Total Amount</span>
            </TableCell>
            <TableCell>
              <span fontWeight="bold">
                {filteredData?.data?.overall_total_amount}
              </span>
            </TableCell>
          </TableRow>

          <TableRow
            sx={{
              position: "sticky",
              bottom: 0,
              zIndex: 2,
              backgroundColor: "var(--cell-bg-color)",
            }}
          >
            <TableCell colSpan={7} align="right">
              <span>Overall Total Percentage</span>
            </TableCell>
            
            <TableCell>
              <span
                style={{
                  color: filteredData?.data?.profit_percentage?.includes("-")
                    ? "red"
                    : "inherit",
                }}
              >
                {filteredData?.data?.profit_percentage}
              </span>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
